module.exports = __webpack_public_path__ + "static/media/3.3.a5524947.png";